/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GDPRConsentLevel } from './GDPRConsentLevel';
import {
    GDPRConsentLevelFromJSON,
    GDPRConsentLevelFromJSONTyped,
    GDPRConsentLevelToJSON,
} from './GDPRConsentLevel';

/**
 * 
 * @export
 * @interface GDPRConsent
 */
export interface GDPRConsent {
    /**
     * 
     * @type {GDPRConsentLevel}
     * @memberof GDPRConsent
     */
    consent_level: GDPRConsentLevel;
    /**
     * Time when this consent was first created for this person
     * @type {Date}
     * @memberof GDPRConsent
     */
    created_at: Date;
}

/**
 * Check if a given object implements the GDPRConsent interface.
 */
export function instanceOfGDPRConsent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "consent_level" in value;
    isInstance = isInstance && "created_at" in value;

    return isInstance;
}

export function GDPRConsentFromJSON(json: any): GDPRConsent {
    return GDPRConsentFromJSONTyped(json, false);
}

export function GDPRConsentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GDPRConsent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'consent_level': GDPRConsentLevelFromJSON(json['consent_level']),
        'created_at': (new Date(json['created_at'])),
    };
}

export function GDPRConsentToJSON(value?: GDPRConsent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'consent_level': GDPRConsentLevelToJSON(value.consent_level),
        'created_at': (value.created_at.toISOString()),
    };
}

